export default {
  GET_ENTERPRISE_PRO_LABOR_MODAL_FORM_SUBMIT:
    "[enterpriseProjects] GET info from submitting Enterprise pro labor modal form",
  // INSERTION_PT (for script, do not remove)
};
